import { useEffect } from 'react';
import LanguageSelector from '@components/LanguageSelector';
import { BUTTONS_ADMIN_TOOLS, HIDE_EVERYTHING_BUTTON, HOMEPAGE_BUTTON_LAYOUT_MTU, WALLED_GARDEN } from '@lib/constants';
import AdvisorButton from '../Buttons/advisorButton';
import EverythingButton from '../Buttons/everythingButton';
import OverviewButton from '../Buttons/overviewButton';
import PersonaliseButton from '../Buttons/personaliseButton';
import ProspectusButton from '../Buttons/prospectusButton';
import ProspectusButtonsV2 from './prospectButtonsV2';
import { useI18n } from '@lib/i18n';
import { HP_ANIMATIONS, HP_ANIMATION_TYPE } from '@lib/constants';

import { staggerAnimations } from '@lib/helpers';
import { initTriggeredAnimations } from '@lib/helpers/blockAnimations';

export default function AdvisorButtons() {
	const { t } = useI18n();

	const animationClass =
		HP_ANIMATIONS && HP_ANIMATION_TYPE ? `animate ${HP_ANIMATION_TYPE} hp-has-triggered-animation` : '';

	const animationData =
		HP_ANIMATIONS && HP_ANIMATION_TYPE
			? {
					'data-hp-trigger-selector': '',
					'data-hp-triggered-animation': HP_ANIMATION_TYPE,
					'data-hp-trigger-event': 'viewport',
					'data-hp-triggered-played': '0',
				}
			: {};

	useEffect(() => {
		staggerAnimations();
		initTriggeredAnimations();
	}, []);

	if (HOMEPAGE_BUTTON_LAYOUT_MTU) {
		return (
			<>
				<ProspectusButtonsV2 />
				<div className="advisor-mode-container mt-6">
					<AdvisorButton />
				</div>
			</>
		);
	}

	return (
		<>
			<PersonaliseButton isAdvisor={true} />
			<LanguageSelector />
			<div className="advisor-mode-container mt-6">
				<p className={`${animationClass}`} {...animationData}>
					{t('home.admin_tools', BUTTONS_ADMIN_TOOLS)}
				</p>
				<AdvisorButton />
				{HIDE_EVERYTHING_BUTTON ? <></> : <EverythingButton isAdvisor={true} />}
				{!WALLED_GARDEN ? (
					<OverviewButton isAdvisor={true} />
				) : (
					<ProspectusButton classes={['outline', 'mb-2', 'outline--home']} />
				)}
			</div>
		</>
	);
}
